module.exports = __webpack_public_path__ + "assets/img/27ec-at.svg";